/**
 * This will generate a unique id that can be used for labels and input fields.
 * In your constructor/componentDidMount, you could call:
 *   this.ids = IdGen.createIds( 'my', 'field1', 'field2' )
 * and then use them in the components : 
 *   <Label htmlFor={this.ids.field1}...>
 *   <TextInput id={this.ids.field1}...>
 * 
 * For Functional components, you can use 
 *   const [ ids ] = useState( IdGen.createId( 'my', 'field1', 'field2' ) )
 * 
 * You can invoke createIds with a number to get back an array.
 *   const [ ids ] = useState( IdGen.createId( 'my', 2 ) )
 *   <Label id={ids[0]}...>
 *   <TextInput id={ids[0]}...> 
 */

// Cache of the ids
const ids = {};
function createId(prefix) {
  const p = prefix || 'id';
  // initialize id for prefix
  if (ids[p] === undefined) {
    ids[p] = 1;
  }
  return `${p}-${ids[p]++}`;
}

/**
 * This can be invoked in two ways: createId( 'xyz', 'k1', 'k2', and 'k3' ) this will 
 * return an object { k1 : 'xyz-1', k2 : 'xyz-2', k3 : 'xyz-3' }. Calling this
 * with a number as the second value will create an array of ids with that prefix:
 * createId( 'xyz', 3 ) will return [ 'xyz-4', 'xyz-5', 'xyz-6' ]
 */
function createIds(prefix, ...keys) {
  if (typeof keys[0] === 'number') {
    const r = [];
    for (let n = 0; n < keys[0]; n++) {
      r.push(createId(prefix));
    }
    return r;
  }
  const r = {};
  for (let n = 0; n < keys.length; n++) {
    r[keys[n]] = createId(prefix);
  }
  return r;
}
export default {
  createId,
  createIds
};
export { createId, createIds };